export function resolvePdfAssetUrl(
  assetId,
  token,
  format,
  pageNumber
) {
  // return `http://localhost:3000/api/deliver/pdf/assets/${assetId}?token=${token}&format=${format}&pageNumber=${pageNumber}`;
  // return `http://192.168.1.11:3000/api/deliver/pdf/assets/${assetId}?token=${token}&format=${format}&pageNumber=${pageNumber}`;
  return `https://cdn-lakshya-app-pdf-private-assets.lakshyakerala.app/${assetId}/${assetId}.${pageNumber}.jpg`;
}
